export default __webpack_public_path__ + "static/media/detail_mobile_11_1.9f34b489.jpg";